import { Drawer } from "@components";
import { Titles } from "../../variables/Titles";

import TextForm from "../types/TextForm";

export const CouponYearForm = ({
  visible,
  onClose,
  node,
  onChange,
  onSave,
  onRemove,
}) => {
  const input_configs = {
    type: "number",
    mask: "9999",
    placeholder: "YYYY",
    format: "YYYY",
    min: 1970,
    max: new Date().getFullYear(),
  };

  return (
    <Drawer
      visible={visible}
      onClose={() => onClose()}
      title={Titles.CouponYear}
      direction="center-right"
      parentSelector={() => document.getElementById("oracle-flow")}
    >
      <TextForm
        node={node}
        input_configs={input_configs}
        onSave={(node) => onSave(node)}
        onRemove={onRemove}
      />
    </Drawer>
  );
};
